<tpm-card rounded-8 class="buffer-card" variant="elevation-basic-20">
  <div class="buffer-card-container">
    <div class="buffer-card__image-container">
      <img class="image" ngSrc="/assets/images/logos/green-energy.svg" fill />
    </div>
    <button
      class="news-button"
      launchpadButton
      ene-outline-button
      rightIcon
      icon="ec_controls_collapsed_dropdown"
      color="primary"
      size="xlarge"
      (click)="newsButtonClicked.emit()"
    >
      {{ "Zum Newsbereich" | translate }}
    </button>
  </div>
</tpm-card>
